import script from "./ResetPasswordForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetPasswordForm.vue?vue&type=script&setup=true&lang=ts"

import "./ResetPasswordForm.vue?vue&type=style&index=0&id=7f188797&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f188797"]])

export default __exports__